// extracted by mini-css-extract-plugin
module.exports = {"root":"ConfirmModal_root__JvPD-","buttonWrapper":"ConfirmModal_buttonWrapper__107Oa"};